export default __webpack_public_path__ + "static/media/marke_4.ca86a4e6.png";